export const opportunitiesRouteNames = {
  default:'opportunities-v2',
  list:'opportunities-list-v2',
  byId:'opportunities-by-id',
  import:'imports',
  pipeline:'pipeline-opportunities-v2',
  BulkActions:'bulk-actions-opportunities'
}
